export default (theme) => ({
  codeMirror: {
    marginLeft: 226,
    background: theme.palette.background.paper,
    padding: 0,
    wordWrap: "break-word",
    maxWidth: "calc(100vw - 226px)",
  },
});
